'use strict';
const angular = require('angular');

/*@ngInject*/
export function RecipientListService($resource) {
  return $resource('/api/recipient-lists/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.RecipientListService', [])
  .factory('RecipientListService', RecipientListService)
  .name;



// WEBPACK FOOTER //
// ./client/services/recipient-list/recipient-list.service.js